
let logPrefix = `\x1b[30;46;1m[Theme]`;

// Cart update function - update VAT when quantity changes
document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('cartcount:update', async () => {

      const section = document.querySelector('[data-section-type="static-cart"]');
      if (!section) return;

      const sectionId = section.dataset.sectionId;
      const url = `/?sections=${sectionId}&section_id=${sectionId}&_=${Date.now()}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch section');

        const html = await response.text();
        const data = JSON.parse(html);
        if (!data[sectionId]) return;

        // Parse the returned HTML into a temporary element
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data[sectionId];

        // Grab the cart-final-total from the new section
        const newFinalTotal = tempDiv.querySelector('.cart-final-total');
        const currentFinalTotal = document.querySelector('.cart-final-total');

        if (newFinalTotal && currentFinalTotal) {
          currentFinalTotal.replaceWith(newFinalTotal);
        } else {
          console.warn("Cart final total element not found in response");
        }

      } catch (err) {
        console.error('Failed to update cart-final-total:', err);
      }

  });
});

function runUpdates() {
  const variantSelects = document.querySelectorAll('variant-selection');
  console.log(logPrefix, "Variant selects found", variantSelects.length);

  variantSelects.forEach(variantSelect => {
    variantSelect.addEventListener('variant-change', async (e) => {
      const section = document.querySelector('.product--section');
      console.log(logPrefix, "Variant change detected in section:", section);

      let url = false;
      if(section){
        url = `${window.location.origin}${window.location.pathname}?variant=${e.detail.variant.id}`;
        url = `${url}&sections[]=${section.id.replace("shopify-section-", "")}`;
        console.log("Section ID:", section.id);
      } else {
        url = `${window.location.origin}${window.location.pathname}/products/${e.detail.product.handle}?variant=${e.detail.variant.id}`;
        url = `${url}&view=quickshop`;
      }

      console.log(logPrefix, "URL", url);

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch section');

        const html = await response.text();
        console.log(logPrefix, "Section HTML received:", html);
        let data = false;
        try {
          data = JSON.parse(html);
          data = data[section.id.replace("shopify-section-", "")];
        } catch (e) {
          console.error("Failed to parse section HTML as JSON:", e);
          data = html;
        }

        console.log(logPrefix, 'Data', data)

        // Parse the returned HTML into a temporary element
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data;

        // Example: update only the VAT / pre-tax price element
        const newVatDiv = tempDiv.querySelector('.product__pre-tax-price');
        console.log(logPrefix, "New VAT element found:", newVatDiv);
        const currentVatDiv = document.querySelector('.product__pre-tax-price');
        console.log(logPrefix, "Current VAT element found:", currentVatDiv);

        if (newVatDiv && currentVatDiv) {
          currentVatDiv.replaceWith(newVatDiv);
          console.log(logPrefix, "VAT element updated successfully");
        } else {
          console.warn(logPrefix, "VAT element not found in response");
        }

      } catch (err) {
        console.error(logPrefix, 'Failed to update variant section:', err);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', runUpdates);

// Product variant change handling - update section on variant change
const observer = new MutationObserver((mutationsList) => {
  let found = false;
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        // Check the node itself
        if (node.matches?.('variant-selection')) {
          found = true;
        }

        // Check any descendants
        node.querySelectorAll?.('variant-selection').forEach((el) => {
          found = true;
        });
      });
    }
  }

  if(found) {
    runUpdates();
  }
});

observer.observe(document.body, { childList: true, subtree: true });